import { render, staticRenderFns } from "./k2Button.vue?vue&type=template&id=15c7dd0c"
import script from "./k2Button.vue?vue&type=script&lang=js"
export * from "./k2Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports